









import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Getter, Mutation } from 'vuex-class';
import { DateOption } from '../models';
import { ReportCsvDownloadResponse, reportDownloaderService } from '../services/reportDownloader';
import { saveAs } from 'file-saver';
import Toast from '@/shared/services/toast';
import { SET_REPORT_LOADING } from '@/store/reports/mutationTypes';

@Component({})
export default class ReportDownloader extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Getter public selectedDateOption!: DateOption;
	@Getter public selectedFlowId!: string;
	@Getter public isReportLoading!: boolean;
	@Mutation(SET_REPORT_LOADING) public setReportLoading: (loading: boolean) => void;

	public isDownloadInProgress: boolean = false;

	public activeRoute: Route;

	public async downloadReport() {
		try {
			this.isDownloadInProgress = true;
			this.setReportLoading(true);
			const report = await this.getReport();
			if (report) {
				saveAs(report.data, report.fileName);
			}
		} catch (error: any) {
			Toast.showError(`Failed to download report: ${error.message}`);
		} finally {
			this.setReportLoading(false);
			this.isDownloadInProgress = false;
		}
	}

	public async getReport(): Promise<ReportCsvDownloadResponse | null> {
		const currentRoute = this.$route.name;

		if (currentRoute === 'reports-overview') {
			return await reportDownloaderService.getMessagingReportCsv(this.currentWorkspace.id, this.selectedDateOption);
		}
		if (currentRoute === 'reports-flows') {
			return reportDownloaderService.getFlowsReportCsv(this.currentWorkspace.id, this.selectedFlowId, this.selectedDateOption);
		}
		if (currentRoute === 'reports-intents') {
			return reportDownloaderService.getNLPReportCsv(this.currentWorkspace.id, this.selectedDateOption);
		}
		if (currentRoute === 'reports-usage') {
			return reportDownloaderService.getUsageReportCsv(this.currentWorkspace.id, this.selectedDateOption);
		}
		return null;
	}
}
